import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalCloseButton,
	ModalBody,
	ModalFooter,
	Button,
	FormControl,
	FormLabel,
	Input,
	Select,
	FormErrorMessage,
} from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { Platform } from '@repo/alictus-common/enums/platform';

// Types
interface ModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: (data: any) => void;
}

interface DeleteModalProps {
	isOpen: boolean;
	onClose: () => void;
	onDelete: () => void;
}

export const CreateModal = ({ isOpen, onClose, onSubmit }: ModalProps) => {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useFormContext();

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Create Mapping</ModalHeader>
				<ModalCloseButton />
				<form onSubmit={handleSubmit(onSubmit)}>
					<ModalBody>
						<FormControl isInvalid={!!errors.platform} mb={4}>
							<FormLabel>Platform</FormLabel>
							<Select {...register('platform', { valueAsNumber: true })} placeholder="Select platform">
								<option value={Platform.iOS}>iOS</option>
								<option value={Platform.Android}>Android</option>
							</Select>
							<FormErrorMessage>{errors.platform?.message?.toString()}</FormErrorMessage>
						</FormControl>

						<FormControl isInvalid={!!errors.version} mb={4}>
							<FormLabel>Version</FormLabel>
							<Input placeholder="e.g., 1.2.3" {...register('version')} />
							<FormErrorMessage>{errors.version?.message?.toString()}</FormErrorMessage>
						</FormControl>

						<FormControl isInvalid={!!errors.buildNumber}>
							<FormLabel>Build Number</FormLabel>
							<Input type="number" {...register('buildNumber')} />
							<FormErrorMessage>{errors.buildNumber?.message?.toString()}</FormErrorMessage>
						</FormControl>
					</ModalBody>
					<ModalFooter>
						<Button colorScheme="blue" type="submit" mr={3}>
							Create
						</Button>
						<Button variant="ghost" onClick={onClose}>
							Cancel
						</Button>
					</ModalFooter>
				</form>
			</ModalContent>
		</Modal>
	);
};

export const EditModal = ({ isOpen, onClose, onSubmit, isDirty }: ModalProps & { isDirty: boolean }) => {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useFormContext();

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Update Mapping</ModalHeader>
				<ModalCloseButton />
				<form onSubmit={handleSubmit(onSubmit)}>
					<ModalBody>
						<FormControl isInvalid={!!errors.platform} mb={4}>
							<FormLabel>Platform</FormLabel>
							<Select {...register('platform', { valueAsNumber: true })}>
								<option value={Platform.iOS}>iOS</option>
								<option value={Platform.Android}>Android</option>
							</Select>
							<FormErrorMessage>{errors.platform?.message?.toString()}</FormErrorMessage>
						</FormControl>

						<FormControl isInvalid={!!errors.version} mb={4}>
							<FormLabel>Version</FormLabel>
							<Input {...register('version')} />
							<FormErrorMessage>{errors.version?.message?.toString()}</FormErrorMessage>
						</FormControl>

						<FormControl isInvalid={!!errors.buildNumber}>
							<FormLabel>Build Number</FormLabel>
							<Input type="number" {...register('buildNumber')} />
							<FormErrorMessage>{errors.buildNumber?.message?.toString()}</FormErrorMessage>
						</FormControl>
					</ModalBody>
					<ModalFooter>
						<Button colorScheme="blue" type="submit" mr={3} isDisabled={!isDirty}>
							Update
						</Button>
						<Button variant="ghost" onClick={onClose}>
							Cancel
						</Button>
					</ModalFooter>
				</form>
			</ModalContent>
		</Modal>
	);
};

export const DeleteModal = ({ isOpen, onClose, onDelete }: DeleteModalProps) => {
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Delete Mapping</ModalHeader>
				<ModalCloseButton />
				<ModalBody>Are you sure you want to delete this mapping?</ModalBody>
				<ModalFooter>
					<Button colorScheme="red" onClick={onDelete} mr={3}>
						Confirm
					</Button>
					<Button variant="ghost" onClick={onClose}>
						Cancel
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};
